import FullWidthImage from "components/full-width-image";
import { useUser } from "contexts/UserContext";
import { useTimeOnPageContext } from "contexts/time-on-page";
import { useEffect } from "react";
import { Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
// import postOrchidPro from "services/postOrchidPro";
import { AmplitudePageName, track } from "utils/amplitude";
import styles from "./styles.module.scss";

const AMPLITUDE_PAGE_NAME: AmplitudePageName = "pro-welcome-subscribe-page";

const SetupSubscription = () => {
  const { user /*, updateUserInfo */ } = useUser();

  const { setPage } = useTimeOnPageContext();
  useEffect(() => setPage(AMPLITUDE_PAGE_NAME), [setPage]);

  // const history = useHistory();

  // const startAIFreeTrial = async () => {
  //   try {
  //     await postOrchidPro({
  //       start_ai_free_trial: true,
  //     });
  //     await updateUserInfo();
  //     history.push("/pro-dashboard/home");
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  return (
    <div className={styles["setup-subscription"]}>
      <div className={styles["setup-subscription__left"]}>
        <FullWidthImage src={"/img/dashboard/welcome-page.svg"} />
      </div>
      <div className={styles["setup-subscription__right"]}>
        <h1 className={styles["setup-subscription__title"]}>
          Welcome to Orchid, {user?.first_name}!
        </h1>
        <Card className={styles["setup-subscription__card"]}>
          <Card.Header className={styles["setup-subscription__card-header"]}>
            <h4 className={"m-0"}>Subscribe to Orchid</h4>
          </Card.Header>
          <Card.Body className={styles["setup-subscription__card-body"]}>
            Compare the features, plans & pricing that have thousands of
            providers switching to Orchid.
          </Card.Body>
          <Card.Footer className={styles["setup-subscription__card-footer"]}>
            <Button
              className="w-100 mb-2"
              as={Link as any}
              to={"/pricing"}
              onClick={() =>
                track(AMPLITUDE_PAGE_NAME, "compare-plans-button", "click")
              }
            >
              Compare plans
            </Button>
            <Button
              className="w-100"
              as={Link as any}
              variant={"outline-primary"}
              to={"/pricing/core/month/trial"}
              onClick={() =>
                track(AMPLITUDE_PAGE_NAME, "start-free-trial-button", "click")
              }
            >
              Free 30-Day EHR Trial
            </Button>
            <Button
              className="w-100 mt-2"
              as={Link as any}
              to={"/pricing/ai-only/month/trial"}
              variant={"outline-primary"}
              onClick={() => {
                track(
                  AMPLITUDE_PAGE_NAME,
                  "start-ai-free-trial-button",
                  "click",
                );
              }}
            >
              Free 30-Day AI Trial
            </Button>
          </Card.Footer>
        </Card>
      </div>
    </div>
  );
};

export default SetupSubscription;
